import Model from '@/shared/orm/Model'
import Customer from './Customer'
import moment from 'moment'
import i18n from '@/plugins/i18n'
import Reseller from './Reseller'

export default class Lead extends Model {
    resourceName() {
        return 'leads'
    }

    fields() {
        return [
            'id',
            'reseller_id',
            'customer_id',
            'trade_name',
            'legal_name',
            'responsible_name',
            'activity_area',
            'cpf',
            'cnpj',
            'email',
            'phone',
            'valid_until',
            'birthday',
            'create_customer',
            'deleted_at',
            'status',
        ]
    }

    dates() {
        return {
            valid_until: 'YYYY-MM-DD',
            birthday: 'YYYY-MM-DD',
            deleted_at: 'YYYY-MM-DD',
        }
    }

    computed() {
        return {
            document(lead) {
                if (lead.cnpj) {
                    return lead.cnpj.replace(
                        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                        '$1.$2.$3/$4-$5',
                    )
                }

                return lead.cpf.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                    '$1.$2.$3-$4',
                )
            },

            hasCustomer(lead) {
                return lead.customer instanceof Customer
            },

            daysLeft(lead) {
                let days = lead.valid_until.diff(moment.now(), 'days')
                return days > 0 ? days : 'Expirado'
            },

            birthday(lead) {
                return lead.birthday._isValid
                    ? lead.birthday.format('DD/MM/YYYY')
                    : ''
            },

            deleted(lead) {
                return lead.deleted_at && lead.deleted_at.isValid()
            },

            statuses() {
                return [
                    'Cadastrado',
                    'Em contato',
                    'Em negociação',
                    'Perdido',
                    'Ativado',
                ]
            },
        }
    }

    get tableColumns() {
        return [
            {
                text: i18n.tc('resources.reseller.name', 1),
                value: 'company',
            },
            {
                text: i18n.tc('resources.customer.name', 1),
                value: 'customer_trade_name',
            },
            {
                text: i18n.tc('resources.contact.name', 2),
                value: 'contacts',
            },
            {
                text: i18n.t('resources.lead.attributes.status'),
                value: 'status',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
                hide: this.tabActive == 'only',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'menu',
                actions: [
                    {
                        type: 'changeReseller',
                        label: i18n.t('actions.lead.changeReseller.label'),
                        disabled: this.customer_id,
                    },
                ],
            },
            {
                type: 'edit',
                to: {
                    name: 'lead.edit',
                    params: { id: this.id },
                },
            },
            {
                type: 'delete',
                disabled: this.id == 1,
            },
        ]
    }

    get searchable() {
        return ['search']
    }

    relationships() {
        return {
            customer: new Customer(),
            reseller: new Reseller(),
        }
    }

    async changeReseller(data) {
        return this.makePersistRequest({
            url: this.getSelfUrl() + '/change-reseller',
            method: 'PUT',
            data: data,
        })
    }
}
